import clsx from 'clsx';
import { forwardRef } from 'react';
import type { StackProps } from './Stack.types';

const alignStyles = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
  baseline: 'items-baseline'
};

const justifyStyles = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly'
};

const Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ spacing = 0, children, align, justify, horizontal = false, divide = false, className, ...props }, ref) => {
    const styles = clsx(
      'flex',
      !horizontal && 'flex-col',
      spacing && (horizontal ? `space-x-${spacing}` : `space-y-${spacing}`),
      align && alignStyles[align],
      justify && justifyStyles[justify],
      divide,
      className
    );

    return (
      <div ref={ref} className={styles} {...props}>
        {children}
      </div>
    );
  }
);

Stack.displayName = 'Stack';

export { Stack };
